import React, { Component } from "react";
import DesktopNavigation from "./navDesktop";
import MobileNavigation from "./NavMobile";

class ResponsiveNavbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      windowSize: window.innerWidth,
    };
  }

  updateWindowSize = () => {
    this.setState({
      windowSize: window.innerWidth,
    });
  };

  componentDidMount() {
    window.addEventListener("resize", this.updateWindowSize);
    this.updateWindowSize(); // set on first mount
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowSize);
  }

  render() {
    const isMobile = this.state.windowSize <= 768;
    return isMobile ? <MobileNavigation /> : <DesktopNavigation />;
  }
}

export default ResponsiveNavbar;
